import { useState, useEffect } from 'react';

const SECTIONS = ['home', 'about', 'projects', 'skills', 'team', 'contact'];

const useNavScroll = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      let cur = 'home';
      SECTIONS.forEach(id => {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 150) cur = id;
      });
      setActiveSection(cur);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return { scrolled, activeSection };
};

export default useNavScroll;
